module.exports = __webpack_public_path__ + "img/032.94a29e9d.png";